module.exports = __webpack_public_path__ + "media/img/home/gallery/gallery6-1924bd466ece1eeb4fd006a888729a51.png";